/** Shared route ownership for navigation, language counterparts, and discovery. */
export type Locale = 'en' | 'ja';

export const publicPages: string[] = [
	'/',
	'/pricing',
	'/docs',
	'/docs/projects',
	'/docs/materials',
	'/docs/snapshots',
	'/docs/time-expressions',
	'/docs/mcp',
	'/docs/unreal',
	'/docs/custom-nodes',
	'/docs/support',
	'/docs/nodes',
	'/privacy-policy',
	'/terms-of-service'
];
export const productPages: string[] = [
	'/start',
	'/projects',
	'/login',
	'/sign-up',
	'/reset-password',
	'/auth/action',
	'/oauth/consent',
	'/activate-early-access',
	'/account-settings',
	'/local',
	'/local-example',
	'/support'
];
const dynamicPages: RegExp[] = [
	/^\/docs\/nodes\/[^/]+$/,
	/^\/projects\/[^/]+$/,
	/^\/workspace\/[^/]+$/,
	/^\/(?:g|m)\/[^/]+$/,
	/^\/examples\/(?:g|m)\/[^/]+$/
];
export function englishPath(pathname: string): string {
	return pathname.replace(/^\/ja(?=\/|$)/, '') || '/';
}
export function hasCounterpart(pathname: string): boolean {
	const path: string = englishPath(pathname).replace(/\/$/, '') || '/';
	return (
		publicPages.includes(path) ||
		productPages.includes(path) ||
		dynamicPages.some((pattern: RegExp) => pattern.test(path))
	);
}
export function publicIndexPage(pathname: string): boolean {
	const path: string = englishPath(pathname);
	return publicPages.includes(path) || /^\/docs\/nodes\/[^/]+$/.test(path);
}
export function localizedPath(href: string, locale: Locale): string {
	if (!href.startsWith('/') || href.startsWith('//')) return href;
	const match: RegExpMatchArray | null = href.match(/^([^?#]*)(.*)$/);
	if (!match || !hasCounterpart(match[1])) return href;
	const path: string = englishPath(match[1]);
	return (locale === 'ja' ? '/ja' + (path === '/' ? '' : path) : path) + match[2];
}
